import Section from './Section';
import useAuth from '../../../hooks/global/useAuth';
import OrderInfo from '../OrderInfo';
import { SectionType } from './CheckoutInfoBag';
import LoginBanner from '../LoginBanner';

interface Props {
  toggleSection: (section: SectionType, open: boolean) => any;
}

export default function OrderInfoSection(props: Props) {
  const { toggleSection } = props;

  const { isGuest } = useAuth();

  return (
    <Section show title="" className="space-y-md">
      {isGuest && <LoginBanner />}
      <OrderInfo toggleSection={toggleSection} />
    </Section>
  );
}
